// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"61":"0b8db74e","68":"f9c38f00"}[chunkId] || chunkId) + "." + {"61":"4f47064ba10d153c","68":"717e101fefe36d41","69":"03b44c3a5c9075ff","252":"528d3d7477b7007a","548":"f325abbcbcb36133","790":"f7d93abcd36f70f2"}[chunkId] + ".js";
};